import gql from 'graphql-tag';

export default gql`
  subscription onDeleteOrder {
    onDeleteOrder {
      __typename
      id
      quantity
      note
      packing
      menuItem {
        id
        title
        price
      }
      userId
      userName
      date
    }
  }
`;



// WEBPACK FOOTER //
// ./src/app/graphql/subscriptions/DeleteOrderSubscription.ts